import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
export const DETAIL_OPEN_STATE_KEY = "detailOpen";
export const useUpdateRouteParam = () => {
  const $ = _c(2);
  const getNewUrl = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (newHouseId_0, options) => {
      const newUrl_0 = getNewUrl(newHouseId_0);
      const state = {
        myStateKey: newHouseId_0 ? DETAIL_OPEN_STATE_KEY : null
      };
      if (options?.replace) {
        window.history.replaceState(state, "", newUrl_0);
      } else {
        window.history.pushState(state, "", newUrl_0);
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleUpdateRouteParams = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      handleUpdateRouteParams,
      getNewUrl
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(newHouseId) {
  const currentParams = new URLSearchParams(window.location.search);
  const params = new URLSearchParams();
  currentParams.forEach((value, key) => {
    if (key !== "modal") {
      params.append(key, value);
    }
  });
  if (newHouseId) {
    params.set("modal", newHouseId.toString());
  }
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  return newUrl;
}